"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var services_1 = require("stremio/services");
var common_1 = require("stremio/common");
var components_1 = require("stremio/components");
var SeasonsBar_1 = __importDefault(require("stremio/routes/MetaDetails/VideosList/SeasonsBar"));
var SideDrawer_less_1 = __importDefault(require("./SideDrawer.less"));
var SideDrawer = (0, react_1.memo)((0, react_1.forwardRef)(function (_a, ref) {
    var seriesInfo = _a.seriesInfo, className = _a.className, closeSideDrawer = _a.closeSideDrawer, selected = _a.selected, props = __rest(_a, ["seriesInfo", "className", "closeSideDrawer", "selected"]);
    var core = (0, services_1.useServices)().core;
    var _b = (0, react_1.useState)(seriesInfo === null || seriesInfo === void 0 ? void 0 : seriesInfo.season), season = _b[0], setSeason = _b[1];
    var _c = (0, react_1.useState)(null), selectedVideoId = _c[0], setSelectedVideoId = _c[1];
    var metaItem = (0, react_1.useMemo)(function () {
        return seriesInfo ? __assign(__assign({}, props.metaItem), { links: props.metaItem.links.filter(function (_a) {
                var category = _a.category;
                return category === common_1.CONSTANTS.SHARE_LINK_CATEGORY;
            }) }) :
            props.metaItem;
    }, [props.metaItem]);
    var videos = (0, react_1.useMemo)(function () {
        return Array.isArray(metaItem.videos) ?
            metaItem.videos.filter(function (video) { return video.season === season; })
            :
                metaItem.videos;
    }, [metaItem, season]);
    var seasons = (0, react_1.useMemo)(function () {
        return props.metaItem.videos
            .map(function (_a) {
            var season = _a.season;
            return season;
        })
            .filter(function (season, index, seasons) {
            return seasons.indexOf(season) === index;
        })
            .sort(function (a, b) { return (a || Number.MAX_SAFE_INTEGER) - (b || Number.MAX_SAFE_INTEGER); });
    }, [props.metaItem.videos]);
    var seasonOnSelect = (0, react_1.useCallback)(function (event) {
        setSeason(parseInt(event.value));
    }, []);
    var seasonWatched = react_1.default.useMemo(function () {
        return videos.every(function (video) { return video.watched; });
    }, [videos]);
    var onMarkVideoAsWatched = (0, react_1.useCallback)(function (video, watched) {
        core.transport.dispatch({
            action: 'Player',
            args: {
                action: 'MarkVideoAsWatched',
                args: [video, !watched]
            }
        });
    }, []);
    var getAltThumbnail = react_1.default.useCallback(function (video, currentSeason) {
        if (currentSeason === null || typeof video.thumbnail !== 'string' || video.thumbnail.length === 0 || typeof video.episode !== 'number' || isNaN(video.episode))
            return '';
        var previousEpisodes = metaItem.videos.filter(function (videoData) {
            return videoData.season !== null && videoData.season !== 0 && videoData.season && videoData.season < currentSeason;
        }).length;
        if (isNaN(previousEpisodes) || previousEpisodes === 0)
            return '';
        //Fallback correction for Animes
        var correctedEpisode = previousEpisodes + video.episode;
        // This regex assumes the URL is in the format:
        // protocol://domain/id/season/episode/rest
        return video.thumbnail.replace(/^(https?:\/\/[^/]+\/[^/]+)\/(\d+)\/(\d+)(\/.*)$/, function (_, base, origSeason, origEpisode, rest) {
            // Replace the season with "1" and the episode with the corrected value
            return "".concat(base, "/1/").concat(correctedEpisode).concat(rest);
        });
    }, [metaItem.videos]);
    var onMarkSeasonAsWatched = function (season, watched) {
        core.transport.dispatch({
            action: 'Player',
            args: {
                action: 'MarkSeasonAsWatched',
                args: [season, !watched]
            }
        });
    };
    var onMouseDown = function (event) {
        event.stopPropagation();
    };
    var onTransitionEnd = (0, react_1.useCallback)(function () {
        setSelectedVideoId(selected);
    }, [selected]);
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(SideDrawer_less_1.default['side-drawer'], className), onMouseDown: onMouseDown, onTransitionEnd: onTransitionEnd },
        react_1.default.createElement("div", { className: SideDrawer_less_1.default['close-button'], onClick: closeSideDrawer },
            react_1.default.createElement(react_2.default, { className: SideDrawer_less_1.default['icon'], name: 'chevron-forward' })),
        react_1.default.createElement("div", { className: SideDrawer_less_1.default['info'] },
            react_1.default.createElement(components_1.MetaPreview, { className: SideDrawer_less_1.default['side-drawer-meta-preview'], compact: true, name: metaItem.name, logo: metaItem.logo, runtime: metaItem.runtime, releaseInfo: metaItem.releaseInfo, released: metaItem.released, description: metaItem.description, links: metaItem.links })),
        seriesInfo ?
            react_1.default.createElement("div", { className: SideDrawer_less_1.default['series-content'] },
                react_1.default.createElement(SeasonsBar_1.default, { season: season, seasons: seasons, onSelect: seasonOnSelect }),
                react_1.default.createElement("div", { className: SideDrawer_less_1.default['videos'] }, videos.map(function (video, index) { return (react_1.default.createElement(components_1.Video, { key: index, className: SideDrawer_less_1.default['video'], id: video.id, title: video.title, thumbnail: video.thumbnail, altThumbnail: getAltThumbnail(video, season), season: video.season, episode: video.episode, released: video.released, upcoming: video.upcoming, watched: video.watched, seasonWatched: seasonWatched, progress: video.progress, deepLinks: video.deepLinks, scheduled: video.scheduled, selected: video.id === selectedVideoId, onMarkVideoAsWatched: onMarkVideoAsWatched, onMarkSeasonAsWatched: onMarkSeasonAsWatched })); })))
            : null));
}));
exports.default = SideDrawer;
